import {Div, Dropdown, InputItem, Label} from 'components';
import {Ecolors} from 'constant';
import React, {useImperativeHandle, useState} from 'react';
import {checkAddress} from 'utils';

interface IValue {
  id: string;
  name: string;
  nameen: string;
}

function RowLBLContent(p: {content: string}) {
  return (
    <Div margin={10}>
      <Label multilanguage={false}>
        <Label>{p.content}</Label>
        {` (`}
        <Label color={Ecolors.red} multilanguage={false}>
          *
        </Label>
        {`)`}
      </Label>
    </Div>
  );
}

function AddressForm(p: {}, ref: any) {
  useImperativeHandle(ref, () => ({
    set: (a: any) => {
      setData(a);
      return;
    },
    get: () => {
      return getData();
    },
    clear: () => {
      clearData();
      return;
    },
  }));
  const [valueNation, setValueNation] = useState<any>(null);
  const [valueProvince, setValueProvince] = useState<any>(null);
  const [address, setAddress] = useState<string>('');

  const setData = (a: {country: IValue; province: IValue; address: string}) => {
    Promise.all([
      setValueNation(a.country),
      setValueProvince(a.province),
      setAddress(a.address),
    ]);
  };

  const getData = () => {
    if (
      checkAddress({
        address,
        valueNation,
        valueProvince,
      })
    ) {
      return {
        country: valueNation,
        province: valueProvince,
        address: address,
      };
    }
    return null;
  };

  const clearData = () => {
    Promise.all([setValueNation(null), setValueProvince(null), setAddress('')]);
  };
  return (
    <>
      <RowLBLContent content={`profile.address`} />
      <InputItem
        value={address}
        onChangeText={a => setAddress(a)}
        marginHorizontal={10}
      />
      <RowLBLContent content={`profile.nation`} />
      <Dropdown
        isActive={true}
        value={valueNation}
        onChange={(a: any) => {
          setValueNation(a);
          setValueProvince(null);
        }}
        url={'country/list'}
        content={'Vui lòng chọn quốc gia'}
      />
      <RowLBLContent content={`profile.city`} />
      <Dropdown
        isActive={!!valueNation}
        url={`province/list?countryId=${valueNation?.id}`}
        content={'Vui lòng chọn tỉnh/thành'}
        value={valueProvince}
        onChange={(a: any) => {
          setValueProvince(a);
        }}
      />
    </>
  );
}

export default React.forwardRef(AddressForm);
